import type {
    CategoriesData,
    FlattenedCategoriesData,
} from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/types";

export const getFlattenedCategoriesData = (categoriesData: CategoriesData): FlattenedCategoriesData => {
    const clonedCategoriesData = structuredClone(categoriesData);
    const flattenedCategoriesData = [];
    clonedCategoriesData.forEach((category) => {
        const { Children = [] } = category;
        Children.forEach((child) => flattenedCategoriesData.push(child));
        delete category.Children;
        if (Object.keys(category).length) {
            flattenedCategoriesData.push(category);
        }
    });
    return flattenedCategoriesData;
};
